import localForage from "localforage";

// Configure localForage to use a specific store.
localForage.config({
  name: "FleetServiceView",
  storeName: "customerData",
  description: "Caches customer data fetched from the server",
});

export default localForage;
